module.exports = {"attributes":{"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M23 12C23 11.4477 22.5523 11 22 11C21.4477 11 21 11.4477 21 12V21H12C11.4477 21 11 21.4477 11 22C11 22.5523 11.4477 23 12 23H21V32C21 32.5523 21.4477 33 22 33C22.5523 33 23 32.5523 23 32V23H32C32.5523 23 33 22.5523 33 22C33 21.4477 32.5523 21 32 21H23V12Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
